<template>
	<section class="image-text-cta-icons">
		<div
			class="bg-white px-[2vw] xl:px-content py-20 2xl:pt-[226px] relative will-change overflow-hidden"
			:data-scroll-section="inner == 'false'"
		>
			<template v-if="blockData.type == 'without Icons with Text'">
				<!-- Orientacion no Icons -->
				<template v-if="blockData.block_orientation === 'text-left'">
					<div
						class="bg-light-blue-03 flex flex-col-reverse xl:flex-row items-center flex-wrap relative xl:py-[6.5vw]"
					>
						<!-- text -->
						<div class="w-full xl:w-1/2 px-[7vw] py-[6.5vw] xl:py-0">
							<div
								class="tracking-desk text-sm mb-8 leading-5 uppercase text-navy-blue-03"
								v-show="blockData.kicker"
							>
								{{ blockData.kicker }}
							</div>
							<h2
								class="text-4xl xl:text-heading mb-8 text-navy-blue-01"
								v-show="blockData.title"
							>
								{{ blockData.title }}
							</h2>
							<div
								class="block-text text-navy-blue-02"
								v-show="blockData.text"
								v-html="blockData.text"
							></div>

							<a
								v-if="blockData.cta || blockData.cta != ''"
								:href="blockData.cta.url"
								class="btn"
								>{{ blockData.cta.title }}
								<svg
									class="ml-6"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M2 12L21 12"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
										stroke-linejoin="round"
									/>
									<path
										d="M18 8L22 12L18 16"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
							</a>
						</div>
						<!-- img -->
						<div
							class="w-full xl:w-1/2 px-[7vw] xl:pl-0 xl:pr-[7vw] mt-[-80px] md:h-[60vh] xl:h-[80vh] overflow-hidden relative xl:absolute xl:bottom-[6.5vw] xl:right-0"
							data-scroll
							data-scroll-speed="1"
							data-scroll-offset="-30%,0"
						>
							<img
								class="w-full h-full"
								v-show="blockData.image"
								:src="blockData.image.url"
								:alt="blockData.image.alt"
							/>
						</div>
						<!-- ./img -->
					</div>
				</template>
				<template v-else>
					<div
						class="bg-light-blue-03 flex flex-col xl:flex-row items-center flex-wrap relative xl:py-[6.5vw]"
					>
						<!-- img -->
						<div
							class="w-full xl:w-1/2 px-[7vw] xl:pr-0 xl:pl-[7vw] mt-[-80px] md:h-[60vh] xl:h-[80vh] overflow-hidden relative xl:absolute xl:bottom-[6.5vw] xl:left-0"
							data-scroll
							data-scroll-speed="1"
							data-scroll-offset="-30%,0"
						>
							<img
								class="w-full h-full"
								v-show="blockData.image"
								:src="blockData.image.url"
								:alt="blockData.image.alt"
							/>
						</div>
						<!-- ./img -->
						<!-- text -->
						<div class="w-full xl:w-1/2 px-[7vw] py-[6.5vw] xl:ml-auto xl:py-0">
							<div
								class="tracking-desk text-sm mb-8 leading-5 uppercase text-navy-blue-03"
								v-show="blockData.kicker"
							>
								{{ blockData.kicker }}
							</div>
							<h2
								class="text-4xl xl:text-heading mb-8 text-navy-blue-01"
								v-show="blockData.title"
							>
								{{ blockData.title }}
							</h2>
							<div
								class="block-text text-navy-blue-02"
								v-show="blockData.text"
								v-html="blockData.text"
							></div>

							<a
								v-if="blockData.cta || blockData.cta != ''"
								:href="blockData.cta.url"
								class="btn"
								>{{ blockData.cta.title }}
								<svg
									class="ml-6"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M2 12L21 12"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
										stroke-linejoin="round"
									/>
									<path
										d="M18 8L22 12L18 16"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
							</a>
						</div>
					</div>
				</template>
				<!-- ./Orientacion no Icons -->
			</template>

			<template v-else>
				<template v-if="blockData.block_orientation === 'text-right'">
					<div
						class="flex items-center flex-wrap bg-light-blue-03 px-[6vw] xl:px-0"
					>
						<div class="relative flex flex-col md:flex-row w-full">
							<!-- img -->
							<div
								class="md:w-[50vw] md:absolute md:top-0 xl:top-auto xl:bottom-0 md:right-[calc(50%+24px)]"
								data-scroll
								data-scroll-speed="1"
								data-scroll-offset="-30%,0"
							>
								<img
									class="-mt-20 w-full h-full"
									v-show="blockData.image"
									:src="blockData.image.sizes.imgasideover"
									:alt="blockData.image.alt"
								/>
							</div>
							<!-- ./img -->
							<!-- text -->
							<div
								class="md:w-1/2 md:ml-auto pt-[6.5vw] pb-20 md:pl-8 xl:px-[7vw]"
								data-scroll
								data-scroll-class="xyz-in"
								data-scroll-repeat="false"
								xyz="fade down duration-15"
							>
								<div
									class="tracking-desk text-sm mb-5 xl:mb-8 leading-5 uppercase text-navy-blue-03"
									v-show="blockData.kicker"
								>
									{{ blockData.kicker }}
								</div>
								<h2
									class="text-4xl xl:text-heading mb-6 xl:mb-8 text-navy-blue-01"
									v-show="blockData.title"
								>
									{{ blockData.title }}
								</h2>
								<div
									class="block-text text-navy-blue-02"
									v-show="blockData.text"
									v-html="blockData.text"
								></div>
								<div
									class="buttons-container-custom flex lg:w-auto w-full lg:flex-row flex-col lg:items-center gap-5"
								>
									<a
										v-if="blockData.cta"
										:href="blockData.cta.url"
										class="btn whitespace-pre-wrap"
										>{{ blockData.cta.title }}
										<svg
											class="ml-6"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M2 12L21 12"
												stroke="#405664"
												stroke-width="1.2"
												stroke-linecap="square"
												stroke-linejoin="round"
											/>
											<path
												d="M18 8L22 12L18 16"
												stroke="#405664"
												stroke-width="1.2"
												stroke-linecap="square"
											/>
										</svg>
									</a>
									<button
										v-if="blockData && blockData.show_modal_cta"
										class="toggle-modal-btn btn whitespace-pre-wrap lg:mt-8 mt-2"
										@click="openModal(blockData.id)"
									>
										{{ blockData.cta_modal_label || "Open Modal" }}
									</button>
								</div>
							</div>
							<!-- ./text -->
						</div>
						<div
							class="text-xl my-8 xl:mx-auto xl:w-10/12"
							v-if="blockData.additional_info"
							v-html="blockData.additional_info"
						></div>
						<template v-if="blockData.icon_style !== 'tabbed'">
							<div
								class="picto-wrap flex flex-wrap justify-center items-center xl:mx-auto pb-[4.5%] 2xl:pt-16 w-full xl:w-10/12 xl:mt-[2rem] 2xl:mt-0"
								v-if="blockData.icons"
							>
								<div
									class="picto flex flex-col self-stretch md:flex-row mb-8 px-2 w-1/2 xl:w-3/12"
									v-show="blockData.icons"
									v-for="(i, index) in blockData.icons"
									:key="index"
								>
									<div
										class="bg-white w-16 h-16 md:w-20 md:h-20 rounded-full shadow-circle flex items-center justify-center flex-shrink-0 mb-3 md:mb-0 md:mr-6"
									>
										<img v-show="i.icon" :src="i.icon.url" :alt="i.icon.alt" />
									</div>
									<div class="text-center xl:text-left">
										<div
											class="text-sm text-navy-blue-03 leading-normal"
											v-show="i.smaller_text"
										>
											{{ i.smaller_text }}
										</div>
										<div
											class="text-lg xl:text-xl font-canela font-light lead leading-normal"
											v-show="i.bigger_text"
										>
											{{ i.bigger_text }}
										</div>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="pt-2 w-full" v-if="blockData.tabbed_icon">
								<ul class="tabs__nav">
									<li
										class="flex flex-col text-lg xl:text-xl leading-snug px-6 xl:px-16"
										:class="{
											'active text-navy-blue-01': activeTab === tab,
											'text-navy-blue-03': activeTab !== tab,
										}"
										v-for="(tab, index) in blockData.tabbed_icon"
										:key="index + tab.tab_title"
										@click="activeTab = tab"
									>
										<div class="cursor-pointer">{{ tab.tab_title }}</div>
									</li>
								</ul>

								<div
									class="picto-wrap flex flex-wrap justify-center items-center xl:mx-auto pb-[4.5%] pt-10 2xl:pt-16 w-full xl:w-10/12 xl:mt-[2rem] 2xl:mt-0"
								>
									<div
										class="picto flex flex-col self-stretch md:flex-row mb-8 px-2 w-1/2 xl:w-3/12"
										v-for="(i, index) in activeTab.icons"
										:key="index"
									>
										<div
											class="bg-white w-16 h-16 md:w-20 md:h-20 rounded-full shadow-circle flex items-center justify-center flex-shrink-0 mb-3 md:mb-0 md:mr-6"
										>
											<img
												v-show="i.icon"
												:src="i.icon.url"
												:alt="i.icon.alt"
											/>
										</div>
										<div class="text-center xl:text-left">
											<div
												class="text-sm text-navy-blue-03 leading-normal"
												v-show="i.smaller_text"
											>
												{{ i.smaller_text }}
											</div>
											<div
												class="text-lg xl:text-xl font-canela font-light lead leading-normal"
												v-show="i.bigger_text"
											>
												{{ i.bigger_text }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</template>

				<template v-else>
					<div class="bg-light-blue-03 px-[6vw] xl:px-0">
						<div
							class="relative flex flex-col-reverse md:flex-row items-center flex-wrap"
						>
							<!-- text -->
							<div class="w-full md:w-1/2 pt-[6.5vw] pb-20">
								<div
									class="xl:w-8/12 xl:mx-auto"
									data-scroll
									data-scroll-repeat="false"
									data-scroll-class="xyz-in"
									xyz="fade down duration-15"
								>
									<div
										class="tracking-desk text-sm mb-5 xl:mb-8 leading-5 uppercase text-navy-blue-03"
										v-show="blockData.kicker"
									>
										{{ blockData.kicker }}
									</div>
									<h2
										class="text-4xl xl:text-heading mb-6 xl:mb-8 text-navy-blue-01"
										v-show="blockData.title"
									>
										{{ blockData.title }}
									</h2>
									<div
										class="block-text text-navy-blue-02"
										v-show="blockData.text"
										v-html="blockData.text"
									></div>
									<div
										class="buttons-container-custom flex lg:w-auto w-full lg:flex-row flex-col lg:items-center gap-5"
									>
										<a
											v-if="blockData.cta"
											:href="blockData.cta.url"
											class="btn whitespace-pre-wrap"
											>{{ blockData.cta.title }}
											<svg
												class="ml-6"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M2 12L21 12"
													stroke="#405664"
													stroke-width="1.2"
													stroke-linecap="square"
													stroke-linejoin="round"
												/>
												<path
													d="M18 8L22 12L18 16"
													stroke="#405664"
													stroke-width="1.2"
													stroke-linecap="square"
												/>
											</svg>
										</a>
										<button
											v-if="blockData && blockData.show_modal_cta"
											class="toggle-modal-btn btn whitespace-pre-wrap lg:mt-8 mt-2"
											@click="openModal(blockData.id)"
										>
											{{ blockData.cta_modal_label || "Open Modal" }}
										</button>
									</div>
								</div>
							</div>
							<!-- img -->
							<div class="md:w-5/12 md:ml-auto xl:ml-0 xl:mr-auto">
								<div
									class="img-holder w-full h-auto relative"
									data-scroll
									data-scroll-speed="1"
									data-scroll-offset="-30%,0"
								>
									<img
										class="w-full -mt-20 xl:mt-[-226px]"
										v-show="blockData.image"
										:src="blockData.image.url"
										:alt="blockData.image.alt"
									/>
								</div>
							</div>
							<!-- ./img -->
						</div>

						<div
							class="text-xl my-8 xl:mx-auto xl:w-10/12"
							v-if="blockData.additional_info"
							v-html="blockData.additional_info"
						></div>

						<template v-if="blockData.icon_style !== 'tabbed'">
							<!-- <template v-if="block.icons"> -->
							<div
								class="picto-wrap flex flex-wrap justify-center items-center xl:mx-auto pb-[4.5%] 2xl:pt-16 w-full xl:w-10/12 xl:mt-[2rem] 2xl:mt-0"
								v-if="blockData.icons"
							>
								<!-- <div class="flex items-center flex-wrap w-full px-[8%] pb-[4.5%]" v-if="blockData.icons"> -->
								<div
									class="picto flex flex-col self-stretch md:flex-row mb-8 px-2 w-1/2 xl:w-3/12"
									v-show="blockData.icons"
									v-for="(i, index) in blockData.icons"
									:key="index"
								>
									<div
										class="bg-white w-16 h-16 md:w-20 md:h-20 rounded-full shadow-circle flex items-center justify-center flex-shrink-0 mb-3 md:mb-0 md:mr-6"
									>
										<img v-show="i.icon" :src="i.icon.url" :alt="i.icon.alt" />
									</div>
									<div class="text-center xl:text-left">
										<div
											class="text-sm text-navy-blue-03 leading-normal"
											v-show="i.smaller_text"
										>
											{{ i.smaller_text }}
										</div>
										<div
											class="text-lg xl:text-xl font-canela font-light lead leading-normal"
											v-show="i.bigger_text"
										>
											{{ i.bigger_text }}
										</div>
									</div>
								</div>
							</div>
							<!-- </template> -->
						</template>

						<template v-else>
							<div class="pt-2 w-full" v-if="blockData.tabbed_icon">
								<ul class="tabs__nav">
									<li
										class="flex flex-col text-lg xl:text-xl leading-snug px-6 xl:px-16"
										:class="{
											'active text-navy-blue-01': activeTab === tab,
											'text-navy-blue-03': activeTab !== tab,
										}"
										v-for="(tab, index) in blockData.tabbed_icon"
										:key="index + tab.tab_title"
										@click="activeTab = tab"
									>
										<div class="cursor-pointer">{{ tab.tab_title }}</div>
									</li>
								</ul>
								<div
									class="picto-wrap flex flex-wrap justify-center items-center xl:mx-auto pb-[4.5%] pt-10 2xl:pt-16 w-full xl:w-10/12 xl:mt-[2rem] 2xl:mt-0"
								>
									<div
										class="picto flex flex-col self-stretch md:flex-row mb-8 px-2 w-1/2 xl:w-3/12"
										v-for="(i, index) in activeTab.icons"
										:key="index"
									>
										<div
											class="bg-white w-16 h-16 md:w-20 md:h-20 rounded-full shadow-circle flex items-center justify-center flex-shrink-0 mb-3 md:mb-0 md:mr-6"
										>
											<img
												v-show="i.icon"
												:src="i.icon.url"
												:alt="i.icon.alt"
											/>
										</div>
										<div class="text-center xl:text-left">
											<div
												class="text-sm text-navy-blue-03 leading-normal"
												v-show="i.smaller_text"
											>
												{{ i.smaller_text }}
											</div>
											<div
												class="text-lg xl:text-xl font-canela font-light lead leading-normal"
												v-show="i.bigger_text"
											>
												{{ i.bigger_text }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</template>
			</template>
		</div>
		<!-- Modal -->
		<transition name="fade">
			<div
				v-if="isModalOpen[blockData.id]"
				class="fixed inset-0 px-6 py-6 w-dvw h-dvh flex items-center justify-center z-50 bg-black/20"
			>
				<div
					class="bg-light-blue-03 md:p-10 p-8 max-w-[1200px] h-fit max-h-[80vh] overflow-y-auto w-full relative shadow-xl"
				>
					<button
						@click="closeModal(blockData.id)"
						class="absolute top-4 left-4 text-gray-500 hover:text-black flex items-center gap-2"
					>
						<span class="text-xl bg-navy-blue-01 text-white px-1.5">✕</span>
						<p class="text-lg">{{ blockData.modal_close_text }}</p>
					</button>
					<div class="offer-modal flex items-center flex-col h-full mt-12">
						<h2 class="text-lg font-medium text-center text-dark-grey">
							{{ blockData.modal_subtitle }}
						</h2>
						<h3 class="text-4xl font-extralight mb-16">
							{{ blockData.modal_title }}
						</h3>
						<div
							class="offer-modal__content mb-6 self-start"
							v-html="blockData.modal_text"
						></div>
						<a
							v-if="blockData.modal_cta_link"
							:href="blockData.modal_cta_link.url"
							target="_blank"
							rel="noopener"
							class="mt-12 flex items-center gap-1 btn px-4 bg-navy-blue-01 text-white hover:bg-navy-blue-03"
						>
							{{ blockData.modal_cta_link.title
							}}<svg
								class="ml-6"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M2 12L21 12"
									stroke="white"
									stroke-width="1.2"
									stroke-linecap="square"
									stroke-linejoin="round"
								/>
								<path
									d="M18 8L22 12L18 16"
									stroke="white"
									stroke-width="1.2"
									stroke-linecap="square"
								/>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</transition>
	</section>
</template>
<script>
export default {
	name: "ImageTextCtaIcons",
	data() {
		return {
			activeTab: false,
			isModalOpen: {},
			blockId: null,
		};
	},
	mounted() {
		this.activeTab = this.blockData.tabbed_icon
			? this.blockData.tabbed_icon[0]
			: false;

		this.blockId =
			this.blockData.id || "block-" + Math.random().toString(36).slice(2, 11);
	},
	methods: {
		openModal(id) {
			this.$set(this.isModalOpen, id, true);
		},
		closeModal(id) {
			this.$set(this.isModalOpen, id, false);
		},
	},
	watch: {
		isModalOpen: {
			handler(val) {
				const open = Object.values(val).some((v) => v);
				const root = this.$root;
				if (open) {
					if (root.scroll && typeof root.scroll.stop === "function")
						root.scroll.stop();
					document.body.classList.add("no-scroll");
					document.documentElement.classList.add("no-scroll");
					document.body.style.overflow = "hidden";
				} else {
					if (root.scroll && typeof root.scroll.start === "function")
						root.scroll.start();
					document.body.classList.remove("no-scroll");
					document.documentElement.classList.remove("no-scroll");
					document.body.style.overflow = "";
				}
			},
			deep: true,
		},
	},
	beforeDestroy() {
		document.body.style.overflow = "";
	},
};
</script>
